import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import logolight from "../assets/images/logo-light.svg";
import logodark from "../assets/images/logo-dark.svg";
import logoicon from "../assets/images/logo-icon.svg";
import { sidebarData } from "./SidebarData";

const Sidebar = (isSidebarSize: any) => {

  const location: any = useLocation();
  const storedData: any = localStorage.getItem("activeMenu");
  const [activeMenu, setActiveMenu] = useState(() => {
    return JSON.parse(storedData) || null;
  });

  const toggleSubMenu = (menu: any) => {
    localStorage.setItem(
      "activeMenu",
      JSON.stringify(activeMenu === menu ? null : menu)
    );
    setActiveMenu(activeMenu === menu ? null : menu);
  };
  


  return (
    <React.Fragment>
      <nav className="sidebar lg:z-[9] z-[10]">
        <div className="h-full bg-white dark:bg-darklight group-data-[sidebar=dark]/item:bg-darklight group-data-[sidebar=brand]/item:bg-sky-950 ">
          <div className="p-4">
            <Link to="index" className="w-full main-logo">
              <img
                src={logodark}
                className="mx-auto dark-logo h-7 logo dark:hidden group-data-[sidebar=dark]/item:hidden group-data-[sidebar=brand]/item:hidden"
                alt="logo"
              />
              <img
                src={logolight}
                className="hidden mx-auto light-logo h-7 logo dark:block group-data-[sidebar=dark]/item:block group-data-[sidebar=brand]/item:block"
                alt="logo"
              />
              <img
                src={logoicon}
                className="hidden mx-auto logo-icon h-7"
                alt=""
              />
            </Link>
          </div>
          <div className="h-[calc(100vh-60px)]  overflow-y-auto overflow-x-hidden px-5 pb-4 space-y-16 detached-menu">
            <ul className="relative flex flex-col gap-1">
              {(sidebarData || []).map((item: any, key: any) => (
                <React.Fragment key={key}>
                  {item.isTitle ? (
                    <h2 className="my-2 text-sm text-black/50 dark:text-white/30 group-data-[sidebar=dark]/item:text-white/30 group-data-[sidebar=brand]/item:text-sky-200/50">
                      <span>{item.label}</span>
                    </h2>
                  ) : item.subItems ? (
                    <>
                      {isSidebarSize && (
                        <li className="menu nav-item">
                          <Link
                            to="#"
                            className={`items-center justify-between text-black nav-link group ${
                              activeMenu === key ||
                              item.subItems.some(
                                (subitem : any) =>
                                  location.pathname === subitem.link
                              )
                                ? "active"
                                : ""
                            }`}
                            onClick={() => toggleSubMenu(key)}
                          >
                            <div className="flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                className="w-5 h-5"
                              >
                                <path d={item.icon} fill="currentColor"></path>
                              </svg>
                              <span className="ltr:pl-1.5 rtl:pr-1.5">
                                {item.label}
                              </span>
                            </div>
                            <div
                              className={`flex items-center justify-center w-4 h-4 dropdown-icon ${
                                activeMenu === key ? "!rotate-180" : ""
                              }`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                className="w-6 h-6"
                              >
                                <path
                                  d="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z"
                                  fill="currentColor"
                                ></path>
                              </svg>
                            </div>
                          </Link>
                        </li>
                      )}
                      <ul
                        style={{
                          display:
                            isSidebarSize && activeMenu === key ? "" : "none",
                        }}
                        className="flex flex-col gap-1 text-black sub-menu dark:text-white/60 group-data-[sidebar=dark]/item:text-white/60 group-data-[sidebar=brand]/item:text-sky-200/50"
                      >
                        {item.subItems.map((subitem: any, subkey: any) => (
                          <React.Fragment key={subkey}>
                            {!subitem.subItems && (
                              <li>
                                <Link
                                  to={subitem.link}
                                  className={
                                    location.pathname === subitem.link
                                      ? "active"
                                      : ""
                                  }
                                >
                                  {subitem.label}
                                </Link>
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <li className="menu nav-item">
                      <Link
                        to={item.link}
                        className={`items-center justify-between text-black nav-link group ${
                          location.pathname === item.link ? "active" : ""
                        }`}
                        onClick={() => toggleSubMenu(key)}
                      >
                        <div className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-5 h-5"
                          >
                            <path d={item.icon} fill="currentColor"></path>
                          </svg>
                          <span className="ltr:pl-1.5 rtl:pr-1.5">
                            {item.label}
                          </span>
                        </div>
                      </Link>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
            <div className="relative p-4 pt-0 text-center rounded-md bg-purple help-box">
              <div className="relative -top-6">
                <span className="text-black mx-auto border border-black/10 shadow-[0_0.75rem_1.5rem_rgba(18,38,63,.03)]  bg-white flex items-center justify-center h-12 w-12 rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </div>
              <h4 className="text-xl text-white">Help Center</h4>
              <p className="mt-4 text-white/70">
                Looks like there might be a new theme soon.
              </p>
              <div className="mt-5">
                <Link to="/#" className="btn-white">
                  Go to help
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Sidebar;

